import React, { useCallback } from 'react';

import SpriteIcon from 'components/uiLibrary/SpriteIcon';
import Typography from 'components/uiLibrary/Typography';

import EntityName from 'components/Globals/EntityName';
import { useShowPageAccessPortalForCasting } from 'components/Globals/PortalsProvider';

import { TP } from 'constants/index';

import useDeviceTypeLayouts from 'utils/hooks/useDeviceTypeLayouts';
import usePageAccessContext from 'utils/hooks/usePageAccessContext';

import { useTranslation } from 'src/i18n';

import classes from './PricingPlanInfo.module.scss';

const PricingPlanInfo = ({ onSelect }) => {
  const { t } = useTranslation('translation');
  const { isDesktop } = useDeviceTypeLayouts();
  const showPageAccessPortalForCasting = useShowPageAccessPortalForCasting();
  const { activePageAccessContext } = usePageAccessContext();

  const setPageAccessContext = useCallback(() => {
    showPageAccessPortalForCasting(onSelect);
  }, [showPageAccessPortalForCasting, onSelect]);

  if (!activePageAccessContext?.entity?.id) {
    return null;
  }

  return (
    <div className={classes.pricingPlanInfo} onClick={setPageAccessContext}>
      {isDesktop && <SpriteIcon icon="keyboard_arrow_down" size={16} className={classes.pricingPlanInfo__icon} />}
      <Typography size={12} color="secondary">
        {t(`${TP}.FN_FOR`)}{' '}
        <Typography size={12} weight="bold">
          <EntityName entityType={activePageAccessContext?.entityType} entity={activePageAccessContext?.entity} />
        </Typography>{' '}
      </Typography>
      {!isDesktop && <SpriteIcon icon="keyboard_arrow_down" size={16} className={classes.pricingPlanInfo__icon} />}
    </div>
  );
};

export default PricingPlanInfo;
